
import { useEffect, type ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';

import { useEmpresa } from '@/context/empresa.context';
import { usePageContext } from '@/context/page.context';

import { ROUTES } from '@/constants/routes.constants';

import EmpresaEdit from './Edit';
import EmpresaShow from './Show';

const Empresa = (): ReactElement => {
	const navigate = useNavigate();
	const { isEdit, setIsEdit } = useEmpresa();
	const { setUrlBack } = usePageContext();

	useEffect(() => {
		setUrlBack({
			show: true,
			label: 'Volver',
			navigate() {
				if (isEdit) {
					setIsEdit(false);
				} else {
					navigate(ROUTES.HOME);
				}
			}
		});
	}, [isEdit]);

	return (
		<>
			{isEdit ? (
				<EmpresaEdit />
			) : (
				<EmpresaShow />
			)}
		</>
	);
};

export default Empresa;